import QuickCashBusiness from './views/quick-cash-business.c';
export default QuickCashBusiness;
